module.exports = __webpack_public_path__ + "static/step6_203-18a4cc996e357fec957c23b329c1c5ef.png";